import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab, Button } from "@mui/material";
import React from "react";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import CustomerListPending from "../../features/manageCustomers/customeListPending";
import CustomerListApproved from "../../features/manageCustomers/customeListApproved";
import CustomerListRejected from "../../features/manageCustomers/customeListRejected";
import CustomerListExpired from "../../features/manageCustomers/customeListExpired";
import FilterMenu from "../../components/filterMenu";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomers = () => {

  const navigate = useNavigate();


  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const location = useLocation();
const tabIndexFromState = location.state?.tabIndex ?? 0;

const [valueTabs, setValueTabs] = React.useState(tabIndexFromState);

  return (
    <MainContainer>
      <div className="main_title d_flex mb_30">
        <h1>User Management</h1>

            <div className="right_s">
        <Button className="btn btn_primary" onClick={()=> navigate('/manage-customers/add')}>
          + Add User
        </Button>
        <Button className="btn btn_primary">
          <img src="/static/images/export_icon.svg" alt="icon" /> Export Data
        </Button>
        
        <FilterMenu />
      </div>

      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Approved" {...a11yProps(1)} />
              <Tab label="Rejected" {...a11yProps(2)} />
              <Tab label="Expired" {...a11yProps(3)} />

            </Tabs>
          </Box>
        </div>
        <div className="right_s">
          <CustomerTopbar />
        </div>
      </div>

      <div className="table_wraper">
        <CustomTabPanel value={valueTabs} index={0}>
          <CustomerListPending />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <CustomerListApproved />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <CustomerListRejected />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <CustomerListExpired />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ManageCustomers;
